import { helpers } from 'hub-web-lib/dist/index-export'
import { ACTIVITY_PATH, DASHBOARD_PATH, appModulesNames } from 'js/constants/app-modules'
import { activityStatusesEnum } from 'js/constants/enums/activity'
import { ERROR, LOW_PROP, PRIMARY, WARNING } from 'js/constants/metrics/common-metrics'
import moment from 'moment'

const getCurrentYear = () => {
    const currentDate = new Date()
    return currentDate.getFullYear()
}

const getSelectedActivityYear = (id, activities = []) => {
    const activity = (activities|| []).find(a => a.id === id)
    if (!activity) return getCurrentYear()
    const startDate = new Date(activity.start_date)
    return startDate.getFullYear()
} 

const getYears = () => {
    const currentYear = getCurrentYear()
    const startYear = currentYear - 5
    const endYear = currentYear + 4
    return Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i)
}

const getFormattedDate = (date) => moment(date).format('MMM')

const getMonths = (selectedYear) => {
    const allMonths = []
    for (let i = 0; i <= 11; i++) {
        const date = new Date()
        date.setFullYear(selectedYear)
        date.setDate(1)
        date.setMonth(i)
        allMonths.push(getFormattedDate(date))
    }
    return allMonths
}


const getGanttColumns = (selectedYear) => {

    const months = getMonths(selectedYear)
    return [{
        key: 'name',
        name: '',
        type: 'string',
        sortable: false,
        filterable: false,
    }, ...months.map((m) => ({
        key: m,
        name: m,
        type: 'gantt',
        sortable: false,
        filterable: false
    }))]
}

const getGanttTableData = (
    selectedYear,
    activitiesData = []
) => {
    const ganttData = activitiesData.map(m => {
        let name = ''
        if ('name' in m) {
            name = m.name
        } else {
            name = appModulesNames[m.module || '']
            if (m.modulePropValue) name = `${name} ${helpers.capitalizeString(m.modulePropValue)}`
        }
        return { ...m, name }
    })
    return ganttData.map((row, i) => getGanttRow(selectedYear, row, i + 1)).filter(row => row)
}

const getActivityStatus = (activity) => {
    const currentDate = new Date()
    let status
    const isComplete = activity.status == activityStatusesEnum.complete || activity.is_complete
    if (isComplete) {
        status = PRIMARY
    } else {
        if (currentDate > new Date(activity.end_date)) {
            status = ERROR
        } else {
            status = currentDate >= new Date(activity.start_date) ? WARNING : LOW_PROP
        }
    }
    return { status, isComplete }
}

const checkOverwrittenColumn = (ganttData, i, endDate) => {
    if (i === 0) return false
    return new Date(endDate).getMonth() >= new Date(ganttData[i - 1].startDate).getMonth()
}

const getActivityStartDate = (activity, selectedYear) => {
    let startDate = activity.start_date
    if (new Date(startDate).getFullYear() < selectedYear) startDate = new Date(selectedYear, 0, 1).toISOString()
    let startColumn = getFormattedDate(startDate)
    return { startDate, startColumn }
}

const getActivityEndDate = (activity, selectedYear, ganttData, i) => {
    let endDate = activity.end_date
    if (new Date(endDate).getFullYear() > selectedYear) endDate = new Date(selectedYear, 11, 1).toISOString()
    
    if (checkOverwrittenColumn(ganttData, i, endDate)) {
        const newEndDate = new Date(new Date(ganttData[i - 1].startDate))
        newEndDate.setMonth(newEndDate.getMonth() - 1)
        endDate = new Date(newEndDate)
    }
    const endColumn = getFormattedDate(endDate)
    return { endDate, endColumn }
}

const filterSortYearActivities = (activities, selectedYear) => {
    return [...activities]
        .filter(a => {
            const startDateYear = new Date(a.start_date).getFullYear()
            const endDateYear = new Date(a.end_date).getFullYear()
            return [startDateYear, endDateYear].includes(selectedYear)
        })
        .sort((a, b) => new Date(b.start_date) - new Date(a.start_date))
}

const getGanttRow = (selectedYear, row, id) => {
    selectedYear = selectedYear * 1
    const { activities, name, link, modulePropValue } = row
    if (!activities || !activities.length) return null
    const selectedYearActivities = filterSortYearActivities(activities, selectedYear)
    let ganttData = []
    let i = 0

    selectedYearActivities.forEach(activity => {
        const { startDate, startColumn } = getActivityStartDate(activity, selectedYear)
        if (!ganttData.map(d => d.startColumn).includes(startColumn) ) {
            const { status, isComplete } = getActivityStatus(activity)
            const { endDate, endColumn } = getActivityEndDate(activity, selectedYear, ganttData, i)

            ganttData.push({
                id: activity.id,
                link: link || helpers.transformToKebab(name),
                isComplete,
                modulePropValue,
                status,
                description: activity.title || activity.description,
                startDate,
                startColumn,
                endDate,
                endColumn,
            })
            i++
        }
    })
    return {
        id,
        name,
        ganttData: ganttData.reverse()
    }
}

const getModuleLink = (activityData, canEditActivity, currentPath) => {
    if (!canEditActivity && !activityData.isComplete) return currentPath
    let moduleLink = activityData.link
    const modulePage = activityData.isComplete ? 
        `${DASHBOARD_PATH}${activityData.modulePropValue ? `-${activityData.modulePropValue}` : ''}` : 
        ACTIVITY_PATH
    return `/${moduleLink}/${modulePage}?id=${activityData.id}`
}

export {
    getCurrentYear, 
    getSelectedActivityYear,
    getGanttColumns, 
    getGanttTableData, 
    getModuleLink, 
    getYears
}